import { ReactNode } from 'react';

export type AddressBookExcelFormColumnType =
  | 'BIZ_NUMBER'
  | 'COMPANY_NAME'
  | 'COMPANY_POSITION'
  | 'DEFAULT_FORWARDING_METHOD'
  | 'DESCRIPTION'
  | 'EMAIL'
  | 'NAME'
  | 'PHONE_NUMBER';

export type FormValue = string[];

export const DATA_START_ROW = 7;
export const ERROR_TOO_MUCH_ROWS = 'ERROR_TOO_MUCH_ROWS';
export const HEADER_ROW_COUNT = 6;
export const addressExcelForm: AddressBookExcelFormColumnType[] = [
  'NAME',
  'DEFAULT_FORWARDING_METHOD',
  'PHONE_NUMBER',
  'EMAIL',
  'DESCRIPTION',
  'COMPANY_NAME',
  'COMPANY_POSITION',
  'BIZ_NUMBER',
];

export const EXCEL_FORM_ERROR_MESSAGE =
  '지원되지 않는 파일 형식입니다.\n엑셀 파일이 맞는지 확인해 주세요.';

export interface ExcelValidationError {
  row: number;
  column: number;
  message: ReactNode;
  type: AddressBookExcelFormColumnType;
}

export function getColumnName(type: AddressBookExcelFormColumnType): string {
  // eslint-disable-next-line default-case
  switch (type) {
    case 'NAME':
      return '이름';
    case 'DEFAULT_FORWARDING_METHOD':
      return '기본 서명 수단';
    case 'PHONE_NUMBER':
      return '휴대폰';
    case 'EMAIL':
      return '이메일';
    case 'DESCRIPTION':
      return '설명';
    case 'COMPANY_NAME':
      return '회사 또는 단체명';
    case 'COMPANY_POSITION':
      return '직급 또는 직책';
    case 'BIZ_NUMBER':
      return '사업자등록번호';
  }

  return type;
}
